import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import trigImage from "../../../images/trigonometry.webp";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الدوال المثلثية - حساب الجيب، جيب التمام، الظل والعكس";
const DESCRIPTION = "حاسبة متقدمة للدوال المثلثية تمكنك من حساب الجيب (sin)، جيب التمام (cos)، الظل (tan) وعكسها بزوايا مختلفة بالدرجات أو الراديان";
const KEYWORDS = "حاسبة مثلثات، دوال مثلثية، sin، cos، tan، arcsin، arccos، arctan، زوايا، راديان، درجات";
const OG_URL = "https://do-calculate.com/calculator/ar/trigonometry/";
function TrigonometryCalculator() {
    const [angle, setAngle] = useState("");
    const [radian, setRadian] = useState("");
    const [selectedFunction, setSelectedFunction] = useState("sin");
    const [result, setResult] = useState("");
    const [error, setError] = useState("");
    const [explanation, setExplanation] = useState("");
    const [angleUnit, setAngleUnit] = useState("degrees");
    const [isInverse, setIsInverse] = useState(false);
    const [fieldsDisabled, setFieldsDisabled] = useState(false);
    const handleCalculate = () => {
        setFieldsDisabled(true);
        setError("");
        setExplanation("");
        let inputValue, calculatedAngle, calculatedRadian;
        let explanationText = "";
        if (angleUnit === "degrees" && angle) {
            inputValue = parseFloat(angle);
            if (isNaN(inputValue)) {
                setError("الرجاء إدخال زاوية صحيحة");
                return;
            }
            calculatedAngle = inputValue;
            calculatedRadian = (inputValue * Math.PI / 180).toFixed(4);
        } else if (angleUnit === "radians" && radian) {
            inputValue = parseFloat(radian);
            if (isNaN(inputValue)) {
                setError("الرجاء إدخال قيمة راديان صحيحة");
                return;
            }
            calculatedRadian = inputValue;
            calculatedAngle = (inputValue * 180 / Math.PI).toFixed(2);
        } else {
            setError("الرجاء إدخال زاوية أو قيمة راديان");
            return;
        }
        let calculationResult;
        const angleRad = angleUnit === "degrees" ? calculatedAngle * Math.PI / 180 : calculatedRadian;
        if (!isInverse) {
            switch (selectedFunction) {
                case "sin":
                    calculationResult = Math.sin(angleRad).toFixed(4);
                    explanationText = `جا(${calculatedAngle}°) = ${calculationResult}\n\nالحساب:\nجا(${calculatedAngle}°) = جا(${calculatedRadian} راديان) = ${calculationResult}`;
                    break;
                case "cos":
                    calculationResult = Math.cos(angleRad).toFixed(4);
                    explanationText = `جتا(${calculatedAngle}°) = ${calculationResult}\n\nالحساب:\nجتا(${calculatedAngle}°) = جتا(${calculatedRadian} راديان) = ${calculationResult}`;
                    break;
                case "tan":
                    if (Math.abs(Math.cos(angleRad)) < 1e-10) {
                        setError(`الظل غير معرف لهذه الزاوية (${calculatedAngle}°)`);
                        return;
                    }
                    calculationResult = Math.tan(angleRad).toFixed(4);
                    explanationText = `ظل(${calculatedAngle}°) = ${calculationResult}\n\nالحساب:\nظل(${calculatedAngle}°) = ظل(${calculatedRadian} راديان) = ${calculationResult}`;
                    break;
            }
        } else {
            if (inputValue < -1 || inputValue > 1) {
                if (selectedFunction === "sin" || selectedFunction === "cos") {
                    setError(`قيمة الإدخال يجب أن تكون بين -1 و 1 للدالة ${selectedFunction}`);
                    return;
                }
            }
            let resultInRadians;
            switch (selectedFunction) {
                case "sin":
                    resultInRadians = Math.asin(inputValue);
                    calculationResult = (resultInRadians * 180 / Math.PI).toFixed(2);
                    explanationText = `الجيب العكسي لـ ${inputValue} = ${calculationResult}°\n\nالحساب:\nجا⁻¹(${inputValue}) = ${resultInRadians.toFixed(4)} راديان = ${calculationResult}°`;
                    break;
                case "cos":
                    resultInRadians = Math.acos(inputValue);
                    calculationResult = (resultInRadians * 180 / Math.PI).toFixed(2);
                    explanationText = `جيب التمام العكسي لـ ${inputValue} = ${calculationResult}°\n\nالحساب:\nجتا⁻¹(${inputValue}) = ${resultInRadians.toFixed(4)} راديان = ${calculationResult}°`;
                    break;
                case "tan":
                    resultInRadians = Math.atan(inputValue);
                    calculationResult = (resultInRadians * 180 / Math.PI).toFixed(2);
                    explanationText = `الظل العكسي لـ ${inputValue} = ${calculationResult}°\n\nالحساب:\nظل⁻¹(${inputValue}) = ${resultInRadians.toFixed(4)} راديان = ${calculationResult}°`;
                    break;
            }
        }
        setResult(calculationResult);
        setExplanation(explanationText);
        if (angleUnit === "degrees") {
            setRadian(calculatedRadian);
        } else {
            setAngle(calculatedAngle);
        }
    };
    const handleReset = () => {
        setAngle("");
        setRadian("");
        setResult("");
        setExplanation("");
        setError("");
        setFieldsDisabled(false);
    };
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
                <div className="col-12 col-md-4 text-center">
                    <img
                        loading="lazy"
                        src={trigImage}
                        alt="حاسبة الدوال المثلثية"
                        width="200"
                        height="200"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: "50px" }}>
                        <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <p>
                                    حاسبة الدوال المثلثية تمكنك من حساب الجيب (sin)، جيب التمام (cos)، الظل (tan)
                                    والعكس (arcsin, arccos, arctan) بزوايا مختلفة بالدرجات أو الراديان.
                                    <br /> تستخدم الدوال المثلثية في العديد من التطبيقات الرياضية والهندسية والفيزيائية.
                                    <br /> يمكنك أيضًا استخدام هذه الأداة للتحقق من نتائجك أو لتعلم كيفية إجراء هذه الحسابات.
                                </p>
                                <br />
                                تستخدم الدوال المثلثية على نطاق واسع في مجالات مثل:
                                <ul>
                                    <li>الهندسة المعمارية والمدنية</li>
                                    <li>الفيزياء والحركة الموجية</li>
                                    <li>الملاحة والخرائط</li>
                                    <li>تحليل الإشارات الإلكترونية</li>
                                </ul>                            </div>
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className="p-3 mb-2 bg-success text-white">
                                    <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                                </div>
                                <div className="bg-warning text-black text-center p-2">
                                    <p>
                                        اختر نوع الدالة ثم أدخل القيمة (زاوية بالدرجات أو راديان للدوال العادية،
                                        أو قيمة بين -1 و1 للدوال العكسية)
                                    </p>
                                </div>
                                <hr />
                                <div dir="rtl">
                                    <div>
                                        <div className="form-group">
                                            <div className="d-flex justify-content-between mb-3">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="angleUnit"
                                                        id="degrees"
                                                        checked={angleUnit === "degrees"}
                                                        onChange={() => setAngleUnit("degrees")}
                                                    />
                                                    <label className="form-check-label" htmlFor="degrees">
                                                        الدرجات
                                                    </label>
                                                </div>
                                                <div className="form-check" style={{ marginRight: "20px" }}>
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="angleUnit"
                                                        id="radians"
                                                        checked={angleUnit === "radians"}
                                                        onChange={() => setAngleUnit("radians")}
                                                    />
                                                    <label className="form-check-label" htmlFor="radians">
                                                        الراديان
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {angleUnit === "degrees" ? (
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label className="form-label ms-2">الزاوية (بالدرجات)</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    placeholder="أدخل الزاوية بالدرجات"
                                                    value={angle}
                                                    onChange={(e) => setAngle(e.target.value)}
                                                    className="form-control"
                                                    style={{ width: "75%" }}
                                                    disabled={fieldsDisabled || isInverse}
                                                />
                                                <span className="input-group-text">°</span>
                                            </div>
                                        ) : (
                                            <div className="form-group d-flex align-items-center">
                                                <b>
                                                    <label className="form-label ms-2">الزاوية (بالراديان)</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    placeholder="أدخل الزاوية بالراديان"
                                                    value={radian}
                                                    onChange={(e) => setRadian(e.target.value)}
                                                    className="form-control"
                                                    style={{ width: "75%" }}
                                                    disabled={fieldsDisabled || isInverse}
                                                />
                                                <span className="input-group-text">rad</span>
                                            </div>
                                        )}
                                        {isInverse && (
                                            <div className="form-group d-flex align-items-center mt-3">
                                                <b>
                                                    <label className="form-label ms-2">القيمة (بين -1 و1)</label>
                                                </b>
                                                <input
                                                    type="number"
                                                    placeholder="أدخل قيمة بين -1 و1"
                                                    value={angleUnit === "degrees" ? angle : radian}
                                                    onChange={(e) => {
                                                        if (angleUnit === "degrees") {
                                                            setAngle(e.target.value);
                                                        } else {
                                                            setRadian(e.target.value);
                                                        }
                                                    }}
                                                    className="form-control"
                                                    style={{ width: "75%" }}
                                                    disabled={fieldsDisabled}
                                                    min="-1"
                                                    max="1"
                                                    step="0.01"
                                                />
                                            </div>
                                        )}
                                        <div className="form-group mt-3">
                                            <label ><b>اختر الدالة المثلثية:</b></label>
                                            <div className="d-flex flex-wrap">
                                                {["sin", "cos", "tan"].map((func) => (
                                                    <div key={func} className="form-check me-3">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="trigFunction"
                                                            id={func}
                                                            checked={selectedFunction === func}
                                                            onChange={() => setSelectedFunction(func)}
                                                            disabled={fieldsDisabled}
                                                        />
                                                        <label className="form-check-label" htmlFor={func} style={{ marginRight: "20px" }}>
                                                            {isInverse ? `${func}⁻¹` : func}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="form-check form-switch mt-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="inverseSwitch"
                                                checked={isInverse}
                                                onChange={() => setIsInverse(!isInverse)}
                                                disabled={fieldsDisabled}
                                            />
                                            <label className="form-check-label" htmlFor="inverseSwitch">
                                                الدوال العكسية
                                            </label>
                                        </div>
                                        <div className="d-flex m-2 mt-4">
                                            <button
                                                className="btn btn-success"
                                                style={{ fontSize: "20px", marginLeft: "10px" }}
                                                onClick={handleCalculate}
                                                disabled={fieldsDisabled}
                                            >
                                                احسب                                            </button>
                                            <button
                                                className="text-white bg-secondary"
                                                style={{ fontSize: "20px" }}
                                                onClick={handleReset}
                                            >
                                                إعادة تعيين
                                            </button>
                                        </div>
                                    </div>
                                    <br />
                                    <div>
                                        { error !== "" ? (
                                            <p className="p-3 mb-2 bg-warning text-white">
                                                خطأ: {error}
                                            </p>
                                        ) : (
                                            explanation && (
                                                <div className="p-3 mb-2 bg-success text-white">
                                                    <h3>النتيجة:</h3>
                                                    {explanation.split("\n").map((line, index) => (
                                                        <p key={index} className="text-white">
                                                            {line}
                                                        </p>
                                                    ))}
                                                </div>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="col-12 col-md-8">
                <div className="info-sections-container">
                    <div className="info-section">
                        <div className="info-section-header">
                            <h3 style={{ fontSize: "16px" }}>ما هي الدوال المثلثية؟</h3>
                        </div>
                        <div className="info-section-body">
                            <p>
                                الدوال المثلثية هي دوال رياضية تربط زوايا المثلث بأطوال أضلاعه.
                                أهم الدوال المثلثية هي الجيب (sin)، جيب التمام (cos)، والظل (tan).
                                تستخدم هذه الدوال في العديد من المجالات مثل الفيزياء، الهندسة، الملاحة،
                                ومعالجة الإشارات.
                            </p>
                        </div>
                    </div>
                    <div className="info-section">
                        <div className="info-section-header">
                            <h3 style={{ fontSize: "16px" }}>الفرق بين الدرجات والراديان</h3>
                        </div>
                        <div className="info-section-body">
                            <p>
                                <strong>الدرجات:</strong> هي وحدة قياس الزوايا حيث تكون الدائرة الكاملة 360 درجة.
                                <br />
                                <strong>الراديان:</strong> هي الوحدة القياسية للزوايا في الرياضيات، حيث تكون الدائرة الكاملة 2π راديان.
                                <br/>                                التحويل بينهما:
                                <br />
                                1 راديان = 180/π درجة ≈ 57.2958 درجة
                                <br />
                                1 درجة = π/180 راديان ≈ 0.01745 راديان
                            </p>
                        </div>
                    </div>
                    <div className="info-section">
                        <div className="info-section-header">
                            <h3 style={{ fontSize: "16px" }}>الدوال المثلثية العكسية</h3>
                        </div>
                        <div className="info-section-body">
                            <p>
                                الدوال المثلثية العكسية (arcsin, arccos, arctan) تعطي الزاوية التي
                                يكون فيها الجيب أو جيب التمام أو الظل مساويًا للقيمة المدخلة.
                                <br/>                                أمثلة:
                                <br />
                                - جا⁻¹(0.5) = 30° أو π/6 راديان
                                <br />
                                - جتا⁻¹(0.5) = 60° أو π/3 راديان
                                <br />
                                - ظل⁻¹(1) = 45° أو π/4 راديان
                            </p>
                        </div>
                    </div>
                    <div className="info-section">
                        <div className="info-section-header">
                            <h3 style={{ fontSize: "16px" }}>مثال عملي على استخدام الحاسبة</h3>
                        </div>
                        <div className="info-section-body">
                            <div className="bg-info text-black p-3 rounded">
                                <p>
                                    لنفترض أنك تريد حساب <strong>sin(30°)</strong>.
                                    <br />
                                    باستخدام الحاسبة:
                                    <ul>
                                        <li>اختر الدالة: <strong>sin</strong></li>
                                        <li>أدخل الزاوية: <strong>30</strong></li>
                                        <li>اختر الوحدة: <strong>درجة</strong></li>
                                        <li>النتيجة: <strong>0.5</strong></li>
                                    </ul>
                                    <hr />
                                    مثال آخر لحساب <strong>arctan(1)</strong>:
                                    <ul>
                                        <li>اختر الدالة: <strong>arctan</strong></li>
                                        <li>أدخل القيمة: <strong>1</strong></li>
                                        <li>اختر الناتج بوحدة الدرجة</li>
                                        <li>النتيجة: <strong>45°</strong></li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default TrigonometryCalculator;